import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPublicHomeData, isExternalLink, normalizeAssetUrl, normalizePublicLink } from "../homeDataCache";

const FALLBACK_FOOTER = [
  { id: "platform", text: "Platform", link: "/jobs", children: [{ id: "jobs", text: "Find Jobs", link: "/jobs" }, { id: "account", text: "Create Account", link: "/register" }] },
  { id: "company", text: "Company", link: "/about-us", children: [{ id: "about", text: "About", link: "/about-us" }, { id: "contact", text: "Contact", link: "/contact-us" }] },
];

const FooterLink = ({ item }) => {
  const link = normalizePublicLink(item?.link);
  return isExternalLink(link)
    ? <a href={link} target={item?.target || "_self"} rel={item?.target === "_blank" ? "noopener noreferrer" : undefined}>{item?.text}</a>
    : <Link to={link} target={item?.target || "_self"}>{item?.text}</Link>;
};

const FooterChildren = ({ items, level = 0 }) => (
  <ul className={`ynb-footer-links level-${level}`}>
    {items.map((item, index) => <li key={item?.id || `${level}-${index}-${item?.text}`}><FooterLink item={item} />{Array.isArray(item?.children) && item.children.length > 0 ? <FooterChildren items={item.children} level={level + 1} /> : null}</li>)}
  </ul>
);

const Footer = () => {
  const [homeData, setHomeData] = useState({});
  useEffect(() => { getPublicHomeData().then(setHomeData).catch(() => setHomeData({})); }, []);
  const groups = Array.isArray(homeData?.footer) && homeData.footer.length ? homeData.footer : FALLBACK_FOOTER;
  const logoUrl = normalizeAssetUrl(homeData?.meta_logo);

  return (
    <footer className="ynb-footer">
      {homeData?.whatsapp && <a className="ynb-whatsapp" href={`https://wa.me/${homeData.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="Contact us on WhatsApp"><i className="ri-whatsapp-line"></i></a>}
      <div className="portal-container">
        <div className="ynb-footer-grid">
          <div className="ynb-footer-brand"><Link to="/" className={`ynb-logo ${logoUrl ? "has-image" : ""}`}>{logoUrl ? <img src={logoUrl} alt={homeData?.meta_title || "Ynbjobs"} /> : <>Ynb<span>jobs</span></>}</Link><p>{homeData?.meta_description || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "}</p>{Array.isArray(homeData?.social_links) && <div className="ynb-socials">{homeData.social_links.map((social, index) => <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.name || `Social link ${index + 1}`} key={social.id || index}><i className={`ri ${social.icon || "ri-external-link-line"}`}></i></a>)}</div>}</div>
          {groups.map((group, index) => <div className="ynb-footer-group" key={group?.id || `${index}-${group?.text}`}><h3>{group?.text}</h3>{Array.isArray(group?.children) && group.children.length ? <FooterChildren items={group.children} /> : <FooterChildren items={[group]} />}</div>)}
        </div>
        <div className="ynb-footer-bottom p"><span>© {new Date().getFullYear()} {homeData?.meta_title || "Ynbjobs"}. All rights reserved.</span><span>{homeData?.footer_credit || "India · Global opportunities"} | Designed by <a href="https://seotowebdesign.com/" target="_blank" rel="noopener noreferrer"> Seo To Webdesign </a></span></div>
      </div>
    </footer>
  );
};

export default Footer;
